// extracted by mini-css-extract-plugin
export default {"toCloseContainer":"ToClose_toCloseContainer__Etp4f","circle":"ToClose_circle__4Xykf","label":"ToClose_label__r7Icm"};